import { BUS_PAGE_MOBILE_URL, trafficTypes } from "../constant"

export interface LocaleField {
  en: string
  th: string
  [k: string]: any
}

export interface IBusData {
  id: string
  title: LocaleField
  origin: LocaleField
  destination: LocaleField
}

export interface ILocationLink {
  id: string
  location: {
    id: string
    [k: string]: any
  }
  name: LocaleField
}
export interface BusData {
  data: IBusData[]
  mobileUrl: string
}

// Inbound (EMP)
const inboundData = [
  {
    id: "inbound-1",
    title: {
      en: "BUS NO. 511",
      th: "หมายเลขรถบัส 511",
    },
    origin: {
      en: "New South",
      th: "สายใต้ใหม่",
    },
    destination: {
      en: "Southern Line",
      th: "สายใต้",
    },
  },
  {
    id: "inbound-2",
    title: {
      en: "BUS NO. 501",
      th: "หมายเลขรถบัส 501",
    },
    origin: {
      en: "Minburi",
      th: "มีนบุรี",
    },
    destination: {
      en: "Hua Lamphong",
      th: "หัวลำโพง",
    },
  },
  {
    id: "inbound-3",
    title: {
      en: "BUS NO. 25",
      th: "หมายเลขรถบัส 25",
    },
    origin: {
      en: "Praksa-Bodin",
      th: "แพรกษา-บดินทร์",
    },
    destination: {
      en: "Tha Chang",
      th: "ท่าช้าง",
    },
  },
  {
    id: "inbound-4",
    title: {
      en: "BUS NO. 508",
      th: "หมายเลขรถบัส 508",
    },
    origin: {
      en: "Pak Nam",
      th: "ปากน้ำ",
    },
    destination: {
      en: "Tha Ratchaworadit",
      th: "ท่าราชวรดิษฐ์",
    },
  },
  {
    id: "inbound-5",
    title: {
      en: "BUS NO. 25",
      th: "หมายเลขรถบัส 25",
    },
    origin: {
      en: "Paknam",
      th: "ปากน้ำ",
    },
    destination: {
      en: "Samyaek (Mo Mi)",
      th: "สามแยก (หมอมี)",
    },
  },
  {
    id: "inbound-6",
    title: {
      en: "BUS NO. 38",
      th: "หมายเลขรถบัส 38",
    },
    origin: {
      en: "Chandrakasem",
      th: "จันทรเกษม",
    },
    destination: {
      en: "Ram 2",
      th: "ราม 2",
    },
  },
  {
    id: "inbound-7",
    title: {
      en: "BUS NO. 48",
      th: "หมายเลขรถบัส 48",
    },
    origin: {
      en: "Ram 2",
      th: "ราม 2",
    },
    destination: {
      en: "Wat Phra Chetuphon (Wat Pho)",
      th: "วัดพระเชตุพน(วัดโพธิ์)",
    },
  },
  {
    id: "inbound-8",
    title: {
      en: "BUS NO. 40",
      th: "หมายเลขรถบัส 40",
    },
    origin: {
      en: "Bangkok Bus Terminal (South Line)",
      th: "สถานีขนส่งผู้โดยสารกรุงเทพ (สายใต้)",
    },
    destination: {
      en: "Talad Lam Salee",
      th: "ตลาดลำสาลี",
    },
  },
  {
    id: "inbound-9",
    title: {
      en: "BUS NO. 98",
      th: "หมายเลขรถบัส 40",
    },
    origin: {
      en: "Huai Kwang",
      th: "หมายเลขรถบัส 98",
    },
    destination: {
      en: "Kluay Nam Tai",
      th: "ห้วยขวาง-กล้วยน้ำใต้",
    },
  },
  {
    id: "inbound-10",
    title: {
      en: "BUS NO. 1-39",
      th: "หมายเลขรถบัส 1-39",
    },
    origin: {
      en: "Siam Park",
      th: "สวนสยาม",
    },
    destination: {
      en: "Khlong Toei",
      th: "คลองเตย",
    },
  },
  {
    id: "inbound-11",
    title: {
      en: "BUS NO. 3-11",
      th: "หมายเลขรถบัส 3-11",
    },
    origin: {
      en: "Ramkhamhaeng 2",
      th: "รามคำแหง 2",
    },
    destination: {
      en: "Wat Pho",
      th: "วัดโพธิ์",
    },
  },
  {
    id: "inbound-12",
    title: {
      en: "BUS NO. 184",
      th: "หมายเลขรถบัส 184",
    },
    origin: {
      en: "Pak Nam",
      th: "ปากน้ำ",
    },
    destination: {
      en: "Mor Chit 2",
      th: "หมอชิต 2",
    },
  },
  {
    id: "inbound-13",
    title: {
      en: "BUS NO. 2",
      th: "หมายเลขรถบัส 2",
    },
    origin: {
      en: "Samrong",
      th: "สำโรง",
    },
    destination: {
      en: "Pak Khlong Talad",
      th: "ปากคลองตลาด",
    },
  },
  {
    id: "inbound-14",
    title: {
      en: "BUS NO. 513",
      th: "หมายเลขรถบัส 513",
    },
    origin: {
      en: "Samrong",
      th: "สำโรง",
    },
    destination: {
      en: "Rangsit",
      th: "รังสิต",
    },
  },
]

export const inbound: BusData = {
  data: inboundData,
  mobileUrl: `${BUS_PAGE_MOBILE_URL}?traffic-type=${trafficTypes.INBOUND}`,
}

const outboundData = [
  {
    id: "outbound-1",
    title: {
      en: "BUS NO. 2",
      th: "หมายเลขรถบัส 2",
    },
    origin: {
      en: "Samrong",
      th: "สำโรง",
    },
    destination: {
      en: "Pak Klong Talad",
      th: "ปากคลองตลาด",
    },
  },
  {
    id: "outbound-2",
    title: {
      en: "BUS NO. 25",
      th: "หมายเลขรถบัส 25",
    },
    origin: {
      en: "Praksa-Bodin",
      th: "แพรกษา-บดินทร์",
    },
    destination: {
      en: "Tha Chang",
      th: "ท่าช้าง",
    },
  },
  {
    id: "outbound-3",
    title: {
      en: "BUS NO. 38",
      th: "หมายเลขรถบัส 38",
    },
    origin: {
      en: "Ramkhamhaeng 2",
      th: "รามคำแหง 2",
    },
    destination: {
      en: "Chandrakasem",
      th: "จันทรเกษม",
    },
  },
  {
    id: "outbound-4",
    title: {
      en: "BUS NO. 508",
      th: "หมายเลขรถบัส 508",
    },
    origin: {
      en: "Pak Nam",
      th: "ปากน้ำ",
    },
    destination: {
      en: "Made Ratchaworadit",
      th: "ทำราชวรดิษฐ์",
    },
  },
  {
    id: "outbound-5",
    title: {
      en: "BUS NO. 48",
      th: "หมายเลขรถบัส 48",
    },
    origin: {
      en: "Ramkhamhaeng University",
      th: "ม.รามคำแหง",
    },
    destination: {
      en: "Wat Phra Chetuphon",
      th: "วัดพระเชตุพน",
    },
  },
  {
    id: "outbound-6",
    title: {
      en: "BUS NO. 98",
      th: "หมายเลขรถบัส 98",
    },
    origin: {
      en: "Huai Kwang",
      th: "ห้วยขวาง",
    },
    destination: {
      en: "Kluay Nam Tai",
      th: "กล้วยน้ำใต้",
    },
  },
  {
    id: "outbound-7",
    title: {
      en: "BUS NO. 501",
      th: "หมายเลขรถบัส 501",
    },
    origin: {
      en: "Suan Siam",
      th: "สวนสยาม",
    },
    destination: {
      en: "Hua Lamphong",
      th: "หัวลำโพง",
    },
  },
  {
    id: "outbound-8",
    title: {
      en: "BUS No. 40",
      th: "รถโดยสารประจำทางหมายเลข 40",
    },
    origin: {
      en: "Bangkok Bus Terminal (South Line)",
      th: "สถานีขนส่งผู้โดยสารกรุงเทพฯ (สายใต้)",
    },
    destination: {
      en: "Talad Lam Salee",
      th: "ตลาดลำสาลี",
    },
  },
  {
    id: "outbound-9",
    title: {
      en: "BUS NO. 184",
      th: "หมายเลขรถบัส 184",
    },
    origin: {
      en: "Pak Nam",
      th: "ปากน้ำ",
    },
    destination: {
      en: "Mor Chit 2",
      th: "หมอชิต 2",
    },
  },
  {
    id: "outbound-10",
    title: {
      en: "BUS NO. 513",
      th: "หมายเลขรถบัส 513",
    },
    origin: {
      en: "Samrong",
      th: "สำโรง",
    },
    destination: {
      en: "Rangsit",
      th: "รังสิต",
    },
  },
]

export const outbound: BusData = {
  data: outboundData,
  mobileUrl: `${BUS_PAGE_MOBILE_URL}?traffic-type=${trafficTypes.OUTBOUND}`,
}
